module.exports = __webpack_public_path__ + "img/48.7.Chla.95e84d5f.png";